module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (10).a19a617f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (10).jpg
// module id = 332
// module chunks = 0